import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { jsPDF } from "jspdf";
import './success.css';  

const Success = () => {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('order_id');
  
  const navigate = useNavigate();


// Function to generate PDF 
const generatePDF = () => {
  const doc = new jsPDF({ 
    orientation: "landscape",  // Set to landscape for horizontal orientation
    unit: "mm",                // Set unit to millimeters
    format: [210, 148.5]       // A4 width (210mm) and half A4 height (148.5mm)
  });

  // Set Header
  doc.setFillColor(10, 2, 86); // #0a0256 color
  doc.rect(0, 0, doc.internal.pageSize.width, 50, 'F'); // Header background color
  doc.addImage('headerlogo.png', 'PNG', 20, 2, 50, 50); // Logo (position and size of logo)

  doc.setTextColor(255, 255, 255); // White text color
  doc.setFontSize(28); // Font size for header text
  doc.text("EYE CARE 2026", doc.internal.pageSize.width / 2, 31, null, null, 'center'); // Centered heading

  // Line space between the header and subheading
  doc.text(" ", doc.internal.pageSize.width / 2, 60); // Space before subheading

  // Subheading - Conference Details
  doc.setTextColor(0, 0, 0); // Black text color
  doc.setFont('helvetica', 'bold'); // Set font to bold
  doc.setFontSize(15); // Smaller font size for subheading
  doc.text("Diyatharippu - 1st International Optometric Conference", doc.internal.pageSize.width / 2, 55, null, null, 'center');
  doc.text("24 - 25 January 2026 in Colombo", doc.internal.pageSize.width / 2, 65, null, null, 'center');

  // Reset to normal font style for subsequent text
  doc.setFont('helvetica', 'normal'); // Set font back to normal

  // Content for the receipt (Payment Successful)
  doc.setFontSize(15); // Reset font size for content
  doc.setTextColor(0, 128, 0); // Green text color for "Payment Successful"
  doc.text("Payment Successful", 20, 80); // Payment status
  doc.setFontSize(12); // Reset font size for content
  doc.text(`Order ID: ${orderId}`, 20, 90); // Order ID with emoji
  doc.text("Thank you for your payment. We're excited to see you at the conference!", 20, 100); // Thank you message with emoji

  // Footer
  doc.setFillColor(10, 2, 86); // Footer background color
  doc.rect(0, doc.internal.pageSize.height - 20, doc.internal.pageSize.width, 20, 'F'); // Footer background
  doc.setTextColor(255, 255, 255); // White text color for footer
  doc.setFontSize(10); // Smaller font size for footer text
  doc.text("EYE CARE 2026", doc.internal.pageSize.width / 2, doc.internal.pageSize.height - 10, null, null, 'center'); // Footer text

  // Save the generated PDF
  doc.save(`Receipt_${orderId}.pdf`);
};

  

  return (
<div className="success-page-container">
  <h1 className="success-header">Payment Successful</h1>
        {/* <p className="order-id">Order ID: {orderId}</p> */}

  <div className="button-wrapper">
    <button className="generate-bill-for-payment" onClick={generatePDF}>
      Download Receipt
    </button>
    <button className="back-to-home" onClick={() => navigate('/')}>
      Return Home
    </button>
  </div>
</div>
  );
};

export default Success;

